/** Score-based color helpers — used across evaluation, prescreen, and admin pages */
/**
 * Evaluations created on or after this instant get the adjusted end-user
 * prescreen display (see {@link prepareScoreForDisplay}). Older evaluations
 * keep their original score so historical numbers stay stable.
 */
export const SCORE_DISPLAY_CUTOFF = new Date('2026-07-07T00:00:00.000Z');
/**
 * Prepare a raw evaluation score for display to END USERS (founders/investors —
 * never admins, who always see the raw stored score).
 *
 * For prescreens created on/after {@link SCORE_DISPLAY_CUTOFF} the score is
 * rounded to the nearest 10 (10, 20, … 100). Deep-eval scores and older
 * prescreens pass through unchanged.
 */
export function prepareScoreForDisplay(score, { isPrescreen, createdAt }) {
    if (!isPrescreen)
        return score;
    const created = typeof createdAt === 'string' ? new Date(createdAt) : createdAt;
    if (created < SCORE_DISPLAY_CUTOFF)
        return score;
    const rounded = Math.round(score / 10) * 10;
    return Math.min(100, Math.max(0, rounded));
}
export function scoreColor(score) {
    if (score >= 75)
        return 'text-emerald-400';
    if (score >= 50)
        return 'text-amber-400';
    return 'text-red-400';
}
export function scoreBg(score) {
    if (score >= 75)
        return 'bg-emerald-400';
    if (score >= 50)
        return 'bg-amber-400';
    return 'bg-red-400';
}
export function scoreHex(score) {
    if (score >= 75)
        return '#34d399';
    if (score >= 50)
        return '#fbbf24';
    return '#f87171';
}
//# sourceMappingURL=scoring.js.map